
    import './styles.scoped.css';
    export default {
  "body-cell": "awsui_body-cell_c6tup_9o7yk_9",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_9o7yk_18",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_9o7yk_30",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_9o7yk_33",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_9o7yk_33",
  "has-footer": "awsui_has-footer_c6tup_9o7yk_33",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_9o7yk_43",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_9o7yk_65",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_9o7yk_69",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_9o7yk_98",
  "has-selection": "awsui_has-selection_c6tup_9o7yk_114",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_9o7yk_117"
};
  